import React, { Component } from 'react';

import PropTypes from 'prop-types';
import L from 'leaflet';
import * as TileBoundary from '../leaflet-plugins/tile-boudaries-layer';


export class FranceActiveMap extends Component {

    constructor(props) {
        super(props);
        this.buildGeoJsonLayerOptions = this.buildGeoJsonLayerOptions.bind(this)
        this.buildHighlightGeoJsonLayerOptions = this.buildHighlightGeoJsonLayerOptions.bind(this)
    }

    componentDidMount() {
        if (this._mountNode) {
            this._map = L.map(this._mountNode, {
                zoomControl: this.props.enableControls,
                doubleClickZoom: this.props.enableControls,
                keyboard: false,
                scrollWheelZoom: false,
                dragging: this.props.enableControls,
                boxZoom: false
            }).setView(this.props.center, this.props.zoom);
            if (this.props.tileLayerUrl) {
                if (this.props.geoJson && this.props.boundary) {
                    this._boundaryLayer = TileBoundary.boundaryCanvas(this.props.tileLayerUrl, {
                        boundary: this.props.geoJson,
                        attribution: this.props.tileLayerAttribution
                    }).addTo(this._map)
                } else {
                    L.tileLayer(
                        this.props.tileLayerUrl,
                        {attribution: this.props.tileLayerAttribution}
                    ).addTo(this._map);
                }
            }
            if (this.props.geoJson) {
                let geoJsonLayerOptions = this.buildGeoJsonLayerOptions()

                const geoJsonAttribution = this.props.geoJsonAttribution;
                if (geoJsonAttribution) {
                    geoJsonLayerOptions["attribution"] = geoJsonAttribution;
                }
                this._geoJsonLayer = L.geoJSON(this.props.geoJson, geoJsonLayerOptions);
                this._geoJsonLayer.addTo(this._map);
                if (this.props.idOnArea) {
                    const areaType = this.props.areaType || "area"
                    this._geoJsonLayer.eachLayer(layer => {
                        if (layer._path) {
                            layer._path.id = `${areaType}-${layer.feature.properties.code}`
                        }
                    })
                }
                if (this.props.registerLayer) {
                    this.props.registerLayer(this._geoJsonLayer)
                }
                if (this.props.fitGeoJsonBounds) {
                    this._map.fitBounds(this._geoJsonLayer.getBounds());
                    this._map.setMinZoom(this._map.getBoundsZoom(this._geoJsonLayer.getBounds()))
                    if (this.props.enableControls) {
                        this._map.setMaxZoom(21);
                    } else {
                        this._map.setMaxZoom(this._map.getBoundsZoom(this._geoJsonLayer.getBounds()))
                    }
                }
            }
            if (this.props.highlightArea) {
                this._highlightArea = L.geoJSON(this.props.highlightArea, this.buildHighlightGeoJsonLayerOptions());
                this._highlightArea.addTo(this._map);
            }

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.geoJson !== this.props.geoJson) {
            // clear and remove all layers
            // add new
            if (this._boundaryLayer) {
                this._boundaryLayer.remove();
            }

            if (this._geoJsonLayer) {
                this._geoJsonLayer.remove();
                if (this._markersLayer) {
                    this._markersLayer.remove();
                }
                this._geoJsonLayer = null;

                if (nextProps.geoJson) {

                    if (nextProps.boundary) {
                        this._boundaryLayer = TileBoundary.boundaryCanvas(nextProps.tileLayerUrl, {
                            boundary: nextProps.geoJson,
                            attribution: nextProps.tileLayerAttribution
                        }).addTo(this._map)
                    }

                    let geoJsonLayerOptions = this.buildGeoJsonLayerOptions()

                    const geoJsonAttribution = nextProps.geoJsonAttribution;
                    if (geoJsonAttribution) {
                        geoJsonLayerOptions["attribution"] = geoJsonAttribution;
                    }
                    this._map.setMaxBounds(null);
                    this._map.setMinZoom(1)
                    this._map.setMaxZoom(22)
                    this._map.setZoom(1)
                    this._geoJsonLayer = L.geoJSON(nextProps.geoJson, geoJsonLayerOptions);
                    this._geoJsonLayer.addTo(this._map);
                    if (nextProps.registerLayer) {
                        nextProps.registerLayer(this._geoJsonLayer)
                    }
                    if (nextProps.fitGeoJsonBounds) {
                        this._map.fitBounds(this._geoJsonLayer.getBounds());
                        if (nextProps.enableControls) {
                            this._map.setMaxZoom(21);
                        } else {
                            this._map.setMaxZoom(this._map.getBoundsZoom(this._geoJsonLayer.getBounds()))
                        }
                    }
                }
            }
        }
        if (nextProps.highlightArea !== this.props.highlightArea) {
            if (this._highlightArea) {
                this._highlightArea.remove();
                this._highlightArea = undefined;
            }
            if (nextProps.highlightArea) {
                this._highlightArea = L.geoJSON(nextProps.highlightArea, this.buildHighlightGeoJsonLayerOptions());
                this._highlightArea.addTo(this._map);
            }
        }

    }

    buildHighlightGeoJsonLayerOptions() {
        return {
            style: {
                fillColor: '#c62222',
                weight: 2,
                opacity: 1,
                color: '#c62222',
                fillOpacity: 1
            },
            onEachFeature: (feature, layer) => {
                layer.on({
                    click: (e) => {
                        if (this.props.clickOnRegion) {
                            this.props.clickOnRegion(feature.properties.code, feature.properties.nom, layer)
                        }
                    }
                });
                layer.bindTooltip(feature.properties.nom, {
                })
            }
        };
    }

    buildGeoJsonLayerOptions() {
        return {
            style: {
                fillColor: '#cccccc',
                weight: 1,
                opacity: 1,
                color: '#2E404F',
                fillOpacity: this.props.boundary ? 0.3 : 0.6,
            },
            onEachFeature: (feature, layer) => {
                layer.id = parseInt(feature.properties.code)
                layer.on({
                    click: (e) => {
                        if (this.props.withSelection) {
                            this._geoJsonLayer.resetStyle();

                            const layer = e.target;
                            layer.setStyle({
                                weight: 5,
                                dashArray: '',
                                fillOpacity: 0.9
                            });
                            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                                layer.bringToFront();
                            }
                        }
                        if (this.props.clickOnRegion) {
                            this.props.clickOnRegion(feature.properties.code, feature.properties.nom, layer)
                        }
                    },
                    mouseover: (e) => {
                        layer.setStyle({
                            weight: 5,
                            color: '#c62222',
                            fillColor: '#cccccc',
                            dashArray: '',
                            fillOpacity: 0.9
                        })
                        layer.bringToFront()
                    },
                    mouseout: (e) => {
                        layer.setStyle({
                            weight: 1,
                            opacity: 1,
                            fillColor: '#cccccc',
                            color: '#2E404F',
                            dashArray: '',
                            fillOpacity: this.props.boundary ? 0.3 : 0.6,
                        })
                        layer.bringToBack()
                    }
                });
                layer.bindTooltip(feature.properties.nom, {
                })
            }
        };
    }

    render() {
        return (
            <div id={this.props.id}
                 className={this.props.customClassName}
                 ref={ (node) => {this._mountNode = node} }>
            </div>
        );
    }
}

FranceActiveMap.propTypes = {
    /**
     * Container id in which map will be displayed
     */
    id: PropTypes.string.isRequired,
    /**
     * Map center ([latitude, longitude] format)
     */
    center: PropTypes.arrayOf(PropTypes.number).isRequired,
    /**
     * Map default zoom
     */
    zoom: PropTypes.number.isRequired,
    /**
     * Map container class name
     */
    customClassName: PropTypes.string,
    /**
     * GeoJSON to display on map
     */
    geoJson: PropTypes.object,
    /**
     * GeoJSON attribution
     */
    geoJsonAttribution: PropTypes.string,
    /**
     * Fits or not map according to geoJSON bounds
     */
    fitGeoJsonBounds: PropTypes.bool,
    /**
     * Tile Layer URL (see leaflet documentation)
     */
    tileLayerUrl: PropTypes.string,
    /**
     * Tile Layer attribution
     */
    tileLayerAttribution: PropTypes.string,
    /**
     * Enable control on map
     */
    enableControls: PropTypes.bool,
    /**
     * Function called when user click on region
     */
    clickOnRegion: PropTypes.func,
    /**
     * Function called to register differents layers (to manage layer on many maps for example)
     */
    registerLayer: PropTypes.func,
    /**
     * Set specific style for selected area
     */
    withSelection: PropTypes.bool,
    boundary: PropTypes.bool,
    highlightArea: PropTypes.object,
    idOnArea: PropTypes.bool,
    areaType: PropTypes.string
}